import { useState } from 'react';
import Button from 'components/button';
import InputField from 'components/fields/InputField';
import UseApi from 'hooks/useApi';

interface PasswordChangeModalProps {
  isOpen: boolean;
  onClose: () => void;
  userId: string;
  userName: string;
}

const PasswordChangeModal = ({ isOpen, onClose, userId, userName }: PasswordChangeModalProps) => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { patchApi } = UseApi();

  const handleSubmit = async () => {
    setError('');
    
    if (newPassword.length < 6) {
      setError('Password must be at least 6 characters long');
      return;
    }
    
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);
    try {
      const response = await patchApi(`users/${userId}/password`, { password: newPassword });
      if (response) {
        alert('Password changed successfully');
        onClose();
        setNewPassword('');
        setConfirmPassword('');
      }
    } catch (err) {
      setError('Failed to change password');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <h2 className="text-xl font-bold mb-4">Change Password</h2>
        <p className="text-sm text-gray-600 mb-4">Changing password for: <strong>{userName}</strong></p>
        
        <div className="space-y-4">
          <InputField
            label="New Password"
            type="password"
            id="newPassword"
            name="newPassword"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="Enter new password"
          />
          
          <InputField
            label="Confirm Password"
            type="password"
            id="confirmPassword"
            name="confirmPassword"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Confirm new password"
          />
          
          {error && (
            <p className="text-red-500 text-sm">{error}</p>
          )}
        </div>
        
        <div className="flex gap-3 mt-6">
          <Button
            onClick={loading || !newPassword || !confirmPassword ? undefined : handleSubmit}
            extraClasses="flex-1"
          >
            {loading ? 'Changing...' : 'Change Password'}
          </Button>
          <Button
            onClick={loading ? undefined : onClose}
            variant="gray"
            extraClasses="flex-1"
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PasswordChangeModal;